module.exports = __webpack_public_path__ + "static/CorprateHp_11-8e98f68f6ef1ae5f23fe8d11ccacba03.jpg";